import { render, staticRenderFns } from "./ProductpagePage.vue?vue&type=template&id=7c224826"
import script from "./ProductpagePage.vue?vue&type=script&lang=js"
export * from "./ProductpagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports